/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'menu-orders': {
    width: 16,
    height: 17,
    viewBox: '0 0 16 17',
    data: '<path pid="0" _fill="#203F6A" fill-rule="evenodd" _stroke="#203F6A" stroke-width=".5" d="M14.65 1H3.45a.345.345 0 00-.35.34v9.888H1v2.386c0 .633.259 1.24.718 1.687.46.448 1.083.699 1.732.699h9.8c.464 0 .91-.18 1.237-.5.329-.319.513-.752.513-1.204V1.34a.337.337 0 00-.103-.241.354.354 0 00-.247-.1zM1.7 13.614v-1.705h9.8v2.387c.002.37.128.728.357 1.023H3.45c-.966 0-1.75-.764-1.75-1.705zm12.6.682c0 .564-.47 1.023-1.05 1.023-.58 0-1.05-.459-1.05-1.023v-2.728a.337.337 0 00-.102-.24.355.355 0 00-.248-.1H3.8V1.68h10.5v12.615zM5.9 5.432c0-.189.157-.34.35-.34h5.6c.193 0 .35.151.35.34 0 .188-.157.34-.35.34h-5.6a.345.345 0 01-.35-.34zm0 2.045c0-.188.157-.34.35-.34h3.5c.193 0 .35.152.35.34a.345.345 0 01-.35.341h-3.5a.345.345 0 01-.35-.34z"/>'
  }
})
